
exports.verificationStatuses = {
  unconfirmed: {
    code: 'unconfirmed',
    display: 'Unconfirmed',
    system: 'bcm',
    version: '1.0.0',
  },
  provisional: {
    code: 'provisional',
    display: 'Provisional',
    system: 'bcm',
    version: '1.0.0',
  },
  differential: {
    code: 'differential',
    display: 'Differential',
    system: 'bcm',
    version: '1.0.0',
  },
  confirmed: {
    code: 'confirmed',
    display: 'Confirmed',
    system: 'bcm',
    version: '1.0.0',
  },
  refuted: {
    code: 'refuted',
    display: 'Refuted',
    system: 'bcm',
    version: '1.0.0',
  },
  'entered-in-error': {
    code: 'entered-in-error',
    display: 'Entered-in-error',
    system: 'bcm',
    version: '1.0.0',
  },
};
